import 'css-chunksrc/client/common/imageCropper/styles.scss';export default {
  "overlay": "_overlay_vpgu2_1",
  "fadeIn": "_fadeIn_vpgu2_1",
  "modal": "_modal_vpgu2_12",
  "slideUp": "_slideUp_vpgu2_1",
  "header": "_header_vpgu2_21",
  "title": "_title_vpgu2_26",
  "body": "_body_vpgu2_33",
  "canvas": "_canvas_vpgu2_41",
  "image": "_image_vpgu2_55",
  "mask": "_mask_vpgu2_65",
  "controls": "_controls_vpgu2_85",
  "hint": "_hint_vpgu2_93",
  "zoomControls": "_zoomControls_vpgu2_100",
  "zoomLabel": "_zoomLabel_vpgu2_108",
  "slider": "_slider_vpgu2_117",
  "footer": "_footer_vpgu2_154",
  "cancelButton": "_cancelButton_vpgu2_163",
  "confirmButton": "_confirmButton_vpgu2_180"
};